module.exports = __webpack_public_path__ + "img/cloudchecksign.1da9398e.png";